import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { Mixpanel } from "../../../../actions/mixpanel.actions";
import * as dropdownsActions from "../../../../actions/dropdowns.actions";
import * as projectActions from "../../../../actions/project.actions";
import * as skillsActions from "../../../../actions/skills.actions";

import ProjectBasics from "../components/ProjectBasics";

const steps = projectId => [
  {
    caption: "Basics",
    url: `/company/project/id/${projectId}/basics`
  },
  {
    caption: "Details",
    url: `/company/project/id/${projectId}/details`
  },
  {
    caption: "Skills",
    url: `/company/project/id/${projectId}/skills`
  },
  {
    caption: "Budget",
    url: `/company/project/id/${projectId}/budget`
  },
  {
    caption: "Review",
    url: `/company/project/id/${projectId}/review`
  }
];

class ProjectBasicsContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      key: _.get(props, "match.params.projectId") || 0,
      manager: _.get(props, "location.state.manager")
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.dropdownsActions.getCompanyBudgets();
    this.props.dropdownsActions.getJobTypes();
    this.props.dropdownsActions.getProjectDurations();
    this.props.skillsActions.getCategories();

    if (this.props.match.params.projectId) {
      this.props.projectActions.getProject(this.props.match.params.projectId);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      if (this.props && this.props.project) {
        this.setState({ key: this.props.project.id });
      } else {
        this.setState({ key: 0 });
      }
    }
  }

  handleSubmit(data) {
    const adminEdit = false;
    const loading = true;

    // Track Mixpanel event
    Mixpanel.track("Project Creation - Basics - Save + Continue");

    if (this.state.manager) {
      data.user_id = this.state.manager;
    }

    if (!this.props.match.params.projectId) {
      this.props.projectActions.createProject(data, "details");
    } else {
      this.props.projectActions.updateProject(
        data,
        "details",
        this.props.match.params.projectId,
        adminEdit,
        loading
      );
    }
  }

  render() {
    return (
      <ProjectBasics
        key={this.state.key}
        categories={this.props.categories}
        companyBudgets={this.props.companyBudgets}
        jobTypes={this.props.jobTypes}
        project={this.props.project}
        projectDurations={this.props.projectDurations}
        steps={steps(this.props.match.params.projectId)}
        onSubmit={this.handleSubmit}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    categories: state.skills.categories.data,
    companyBudgets: state.dropdowns.companyBudgets.data,
    jobTypes: state.dropdowns.jobTypes.data,
    project: state.project.data.data,
    projectDurations: state.dropdowns.projectDurations.data
  };
};

const mapDispatchToProps = dispatch => ({
  dropdownsActions: bindActionCreators(dropdownsActions, dispatch),
  projectActions: bindActionCreators(projectActions, dispatch),
  skillsActions: bindActionCreators(skillsActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProjectBasicsContainer);



// WEBPACK FOOTER //
// ./src/routes/employer/project/containers/ProjectBasicsContainer.js